<template>
	<div
		class="availability"
		:class="{ 'availability--readonly': readonly }">
		<div
			v-if="tempWorker.unavailabilities?.length"
			class="unavailabilities">
			<o-alert color="warning">
				<div class="unavailabilities__alert-content">
					{{ tempWorker.firstName ?? `L'intérimaire` }} a renseigné des indisponibilités
					<o-button
						nude
						color="warning"
						:suffix-font-icon="setup.showUnavailabilities ? 'icon-interface-arrows-button-up': 'icon-interface-arrows-button-down'"
						size="xs"
						@click="setup.showUnavailabilities = !setup.showUnavailabilities">
						{{ setup.showUnavailabilities ? 'Masquer': 'Afficher' }}
					</o-button>
				</div>
			</o-alert>

			<o-card
				v-if="tempWorker.unavailabilities.length && setup.showUnavailabilities"
				title="Indisponibilités">
				<div
					v-for="unavailability in tempWorker.orderedUnavailabilities"
					:key="unavailability.id"
					class="specific-availability">
					<o-icon
						class="specific-availability__icon"
						font-icon="icon-interface-calendar-mark"/>
					<strong>
						Du {{ unavailability.startDate.toReadable() }}
						au {{ unavailability.endDate.toReadable() }}
					</strong>
				</div>
			</o-card>
		</div>

		<div v-if="!tempWorker.availabilities">
			<o-alert
				center
				color="info">
				{{ tempWorker.firstName ?? `L'intérimaire` }} n'a pas encore renseigné ses disponibilités
			</o-alert>
		</div>

		<div v-else-if="tempWorker.availabilities.isAvailable || tempWorker.isAvailableNow">
			<o-alert
				center
				color="info"
				class="availability--label">
				{{ tempWorker.firstName ?? `L'intérimaire` }} est disponible {{ tempWorker.availabilityLabel }}
			</o-alert>
			<br>
			<o-section title="La semaine">
				<user-profile-availability-day
					v-model="tempWorker.availabilities.monday"
					day="monday"
					readonly/>
				<user-profile-availability-day
					v-model="tempWorker.availabilities.tuesday"
					day="tuesday"
					readonly/>
				<user-profile-availability-day
					v-model="tempWorker.availabilities.wednesday"
					day="wednesday"
					readonly/>
				<user-profile-availability-day
					v-model="tempWorker.availabilities.thursday"
					day="thursday"
					readonly/>
				<user-profile-availability-day
					v-model="tempWorker.availabilities.friday"
					day="friday"
					readonly/>
			</o-section>

			<o-section title="Le weekend">
				<user-profile-availability-day
					v-model="tempWorker.availabilities.saturday"
					day="saturday"
					readonly/>
				<user-profile-availability-day
					v-model="tempWorker.availabilities.sunday"
					day="sunday"
					readonly/>
			</o-section>
		</div>

		<div v-else-if="tempWorker.availabilities.availabilityDate && !tempWorker.availabilities.isAvailable">
			<o-alert
				center
				color="warning">
				{{ tempWorker.firstName ?? `L'intérimaire` }} sera disponible {{ tempWorker.availabilityLabel }}
			</o-alert>
		</div>

		<div v-else>
			<o-alert
				center
				color="warning">
				{{ tempWorker.firstName ?? `L'intérimaire` }} n'est pas disponible
			</o-alert>
		</div>
	</div>
</template>

<script setup lang="ts">
import UserProfileAvailabilityDay from '../user-profile/UserProfileAvailabilityDay.vue';
import TempWorkerAvailabilitySetupService from '@/setup/temp-worker/TempWorkerAvailabilitySetupService';
const props = defineProps(TempWorkerAvailabilitySetupService.props);
const setup = new TempWorkerAvailabilitySetupService(props);
</script>

<style scoped lang="less">
.unavailabilities {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &__alert-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.specific-availability {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 0.25rem;
  background: var(--grey-lighter);
  font-size: 0.85rem;

  & + & {
    margin-top: 0.75rem;
  }

  &__icon {
    font-size: 1rem;
    margin-right: 1rem;
  }
}
</style>
